const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/cioinsights/api-factory');
const serviceFactory = require('../resources/cioinsights/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/cioinsights/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}cioinsights.getData[{keys:roleid}][{keys:count}][{keys:limit}][{keys:cache}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getCioInsightsData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}cioinsights.getArticle[{keys:articleId}][{keys:cache}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getArticle(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}cioinsights.getAttachment[{keys:attachmentId}][{keys:cache}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getAttachment(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}cioinsights.getSearchData[{keys:roleid}][{keys:searchKeyword}][{keys:lazyLoadingCount}][{keys:pageLimit}][{keys:cache}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getCioSearchsData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))


  }

module.exports = addRoutes;
